import { useCurrentProductContext } from './useCurrentProductContext';

export const useCurrentStacklineSku = (): string | undefined => {
  return useCurrentProductContext().stacklineSku;
};
